import { CHANGE_SYSTEM } from "./types";

export function changeSystem( system ){
    return {
        type: CHANGE_SYSTEM,
        payload: system
    };
}